/** * Created by lobin on 2019/2/1. */
<template>
  <div class="work-edit">
    <el-form
      :model="project"
      ref="project"
      label-width="100px"
      class="myresume-form"
      :rules="rules"
      label-position="left"
    >
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item label="项目名称：" prop="projectName">
            <el-input
              v-model="project.projectName"
              placeholder="请输入项目名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="项目角色：" prop="projectRole">
            <el-input
              v-model="project.projectRole"
              placeholder="请输入项目角色"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="开始时间：" prop="projectStartDate">
            <el-date-picker
              type="month"
              placeholder="开始时间"
              v-model="project.projectStartDate"
              value-format="yyyy-MM"
              :picker-options="pickerOptionsStart"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="结束时间：" required>
            <el-row>
              <el-col :span="18">
                <el-date-picker
                  type="month"
                  placeholder="结束时间"
                  v-model="project.projectEndDate"
                  style="width: 100%"
                  value-format="yyyy-MM"
                  :disabled="projectEndDate"
                  :picker-options="pickerOptionsEnd"
                ></el-date-picker>
              </el-col>
              <el-col :span="6">
                <el-checkbox
                  v-model="projectEndDate"
                  style="margin-left: 10px"
                  @change="selectToday"
                  >至今</el-checkbox
                >
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="项目职责：" prop="projectDuty">
            <quill-editor
              v-model="project.projectDuty"
              ref="myQuillEditor"
              :options="editorOption"
            >
            </quill-editor>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="项目描述：" prop="projectDescription">
            <quill-editor
              v-model="project.projectDescription"
              ref="myQuillEditor"
              :options="editorOption"
            >
            </quill-editor>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="项目技术栈：">
            <quill-editor
              v-model="project.achievement"
              ref="myQuillEditor"
              :options="editorOption"
            >
            </quill-editor>
          </el-form-item>
        </el-col>
        <el-col :span="24" style="text-align: center">
          <el-button @click="next"> {{ cancelText }}</el-button>
          <el-button type="primary" @click="addAction">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions } from "vuex";
import ElRow from "element-ui/packages/row/src/row";
export default {
  components: { ElRow },
  props: ["value", "index", "type", "cancelText"],
  data() {
    return {
      projectEndDate: false,
      editorOption: {},
      project: {}
    };
  },
  created() {
    if (this.value.projectEndDate == "1970-01") {
      this.project = Object.assign(this.value, { projectEndDate: new Date() });
      this.projectEndDate = true;
    }
    this.project = this.value;
  },
  computed: {
    ...mapGetters(["industryType"]),
    // pickerOptionsStart(){
    //   const projectEndDate = this.project.projectEndDate;
    //   return {
    //     disabledDate(time){
    //       if(projectEndDate){
    //         if(this.projectEndDate){
    //           return time.getTime() > Date.now() - 8.64e6;
    //         }
    //         return time.getTime() >  new Date(projectEndDate).getTime();
    //       }
    //       return time.getTime() > Date.now() - 8.64e6;
    //     }
    //   }
    // },
    // pickerOptionsEnd(){
    //   return {
    //     disabledDate(time){
    //       return time.getTime() > Date.now() - 8.64e6;
    //     }
    //   }
    // },
    // 时间结束判断
    pickerOptionsEnd() {
      const _this = this;
      return {
        disabledDate(time) {
          if (_this.project.projectStartDate) {
            return (
              time.getTime() <=
                new Date(_this.project.projectStartDate).getTime() ||
              time.getTime() > Date.now() - 8.64e6
            );
          } else {
            return time.getTime() > Date.now() - 8.64e6;
          }
        }
      };
    },
    // 时间起始判断
    pickerOptionsStart() {
      const _this = this;
      return {
        disabledDate(time) {
          if (_this.project.projectEndDate) {
            return (
              time.getTime() >=
                new Date(_this.project.projectEndDate).getTime() ||
              time.getTime() > Date.now() - 8.64e6
            );
          } else {
            return time.getTime() > Date.now() - 8.64e6;
          }
        }
      };
    },
    rules() {
      return {
        projectName: [
          { required: true, trigger: "blur", message: "项目名称必填" }
        ],
        projectRole: [
          { required: true, trigger: "blur", message: "项目角色必填" }
        ],
        projectStartDate: [
          { required: true, trigger: "change", message: "开始时间必填" }
        ],
        projectEndDate: [
          { required: true, trigger: "change", message: "结束时间必填" }
        ],
        projectDuty: [
          { required: true, trigger: "change", message: "项目职责内容必填" }
        ],
        projectDescription: [
          { required: true, trigger: "change", message: "项目描述必填" }
        ]
      };
    },
    educationRules() {
      return {};
    }
  },
  methods: {
    ...mapActions(["addProjectExperience", "editProjectExperience"]),
    async addAction() {
      const validate = await this.$refs["project"].validate();
      if (!validate) return;
      console.log(this.type);
      const actionType =
        this.type == "edit" ? "editProjectExperience" : "addProjectExperience";
      const data = Object.assign({}, this.project);
      console.log(this.projectEndDate);

      if (this.projectEndDate) {
        data.projectEndDate = "1970-01";
      }
      const res = await this[actionType](data);
      if (res.code === 200) {
        if (this.type !== "edit") {
          this.$emit("input", res.data);
        }
        this.$emit("submit", { index: this.index });
        this.$message.success("成功");
      } else {
        this.$message.error(res.message);
      }
    },
    selectToday() {
      if (this.projectEndDate) {
        this.project.projectEndDate = new Date();
      }
    },
    next() {
      this.$emit("submit", { index: this.index, type: "skip" });
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.education-edit {
}
</style>
